// extracted by mini-css-extract-plugin
module.exports =  {"dropdown":"_2787e5dfdf--dropdown--DX7TI"};